const nav = document.getElementById("nav")!;
const progress = document.getElementById("progress")!;

const sections = Array.from(document.querySelectorAll<HTMLElement>("main section"));
const dots = Array.from(document.querySelectorAll<HTMLAnchorElement>(".dots a"));
const navLinks = Array.from(document.querySelectorAll<HTMLAnchorElement>(".nav-links a"));
const navLinkById = Object.fromEntries(navLinks.map((a) => [a.dataset.target, a]));

function currentSectionIndex(): number {
  const maxY = document.documentElement.scrollHeight - window.innerHeight;
  if (maxY - window.scrollY < 4) return sections.length - 1;
  const y = window.scrollY + window.innerHeight * 0.35;
  let idx = 0;
  sections.forEach((s, i) => {
    if (s.offsetTop <= y) idx = i;
  });
  return idx;
}

function updateScrollState(): void {
  if (window.scrollY > 20) nav.classList.add("scrolled");
  else nav.classList.remove("scrolled");

  const max = document.documentElement.scrollHeight - window.innerHeight;
  const ratio = max > 0 ? Math.min(1, window.scrollY / max) : 0;
  progress.style.transform = `scaleX(${ratio})`;

  const idx = currentSectionIndex();
  const activeId = sections[idx]?.id;
  dots.forEach((d, i) => d.classList.toggle("active", i === idx));
  navLinks.forEach((a) => a.classList.remove("active"));
  if (activeId && navLinkById[activeId]) navLinkById[activeId].classList.add("active");
}

window.addEventListener("scroll", updateScrollState, { passive: true });
window.addEventListener("resize", updateScrollState);
updateScrollState();

const io = new IntersectionObserver(
  (entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        e.target.classList.add("in");
        io.unobserve(e.target);
      }
    }
  },
  { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
);
document.querySelectorAll(".stagger, .stagger-hero").forEach((el) => io.observe(el));

let scrollAnim: number | null = null;

function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function smoothScrollTo(y: number, duration = 700): void {
  if (scrollAnim) cancelAnimationFrame(scrollAnim);
  const startY = window.scrollY;
  const maxY = document.documentElement.scrollHeight - window.innerHeight;
  const targetY = Math.max(0, Math.min(maxY, y));
  const dist = targetY - startY;
  if (Math.abs(dist) < 2) return;

  const d = Math.max(400, Math.min(duration, Math.abs(dist) * 0.65));
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, targetY);
    return;
  }

  const startT = performance.now();
  const step = (now: number): void => {
    const t = Math.min(1, (now - startT) / d);
    window.scrollTo(0, startY + dist * easeInOutCubic(t));
    if (t < 1) scrollAnim = requestAnimationFrame(step);
    else scrollAnim = null;
  };
  scrollAnim = requestAnimationFrame(step);
}

function cancelScrollAnim(): void {
  if (scrollAnim) {
    cancelAnimationFrame(scrollAnim);
    scrollAnim = null;
  }
}

window.addEventListener("wheel", cancelScrollAnim, { passive: true });
window.addEventListener("touchstart", cancelScrollAnim, { passive: true });

document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    const href = a.getAttribute("href");
    if (!href || href === "#") return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    const navH = nav.getBoundingClientRect().height;
    const el = target as HTMLElement;
    const top = el.getBoundingClientRect().top + window.scrollY - (el.id === "top" ? 0 : navH - 8);
    smoothScrollTo(top);
    history.replaceState(null, "", href);
  });
});

function scrollToIdx(i: number): void {
  const target = sections[Math.max(0, Math.min(sections.length - 1, i))];
  if (!target) return;
  const navH = nav.getBoundingClientRect().height;
  const top = target.getBoundingClientRect().top + window.scrollY - (i === 0 ? 0 : navH - 8);
  smoothScrollTo(top);
}

function isTypingTarget(el: Element | null): boolean {
  return !!(
    el &&
    (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || (el as HTMLElement).isContentEditable)
  );
}

let hintHidden = false;
const hint = document.getElementById("kbdHint")!;
const mobileHint = matchMedia("(max-width: 560px)");

function hideHint(): void {
  if (hintHidden) return;
  hintHidden = true;
  hint.classList.remove("show");
  hint.classList.add("hide");
}

if (!mobileHint.matches) {
  setTimeout(() => {
    if (!hintHidden) hint.classList.add("show");
  }, 1200);
  setTimeout(hideHint, 12000);
}

window.addEventListener("keydown", (e) => {
  if (isTypingTarget(document.activeElement)) return;
  if (e.metaKey || e.ctrlKey || e.altKey) return;

  const idx = currentSectionIndex();
  let handled = true;
  switch (e.key) {
    case "ArrowDown":
    case "PageDown":
    case "j":
      scrollToIdx(idx + 1);
      break;
    case "ArrowUp":
    case "PageUp":
    case "k":
      scrollToIdx(idx - 1);
      break;
    case "Home":
      scrollToIdx(0);
      break;
    case "End":
      scrollToIdx(sections.length - 1);
      break;
    default:
      handled = false;
  }
  if (handled) {
    e.preventDefault();
    hideHint();
  }
});

const toast = document.getElementById("toast")!;
let toastTimer: ReturnType<typeof setTimeout> | null = null;

function showToast(msg: string): void {
  toast.textContent = msg;
  toast.classList.add("show");
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove("show"), 1800);
}

document.querySelectorAll<HTMLButtonElement>(".copy-btn").forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const text = btn.dataset.copy;
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      showToast("Copied — " + text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        showToast("Copied — " + text);
      } catch {
        showToast("Press ⌘/Ctrl+C to copy");
      }
      document.body.removeChild(ta);
    }
  });
});
